import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { adminMainUrl } from '../../../../../../../Config';
import { toast } from 'react-toastify';
import Select from 'react-select'
import { customStyles } from '../../../../../../../HelperFunctions';
import InputTextJSX from './InputTextJSX';
import { useDispatch, useSelector } from 'react-redux';
import { getFFSeaImpConsigneeBranch, getFFSeaImpConsigneeBranchBank, getFFSeaImpShipperBranch, getFFSeaImpShipperBranchBank, getFFSICity, getFFSICountry, getFFSISeaport, getFFSIState } from '../../../../../../../Redux/action/FreightForwarding/Sea/FFSeaImpAction';
import { Link, useNavigate } from 'react-router-dom';

const DirectShipmentSIMBLEdit = ({
    trans_mode,
    job_order_id,
    quotation_id,
    loadingCurrency,
    currencyOptions,
    loadingAirport,
    airportOptions,
    loadingOrganisation,
    organisationOptions,
    token,
    user_id,
    FFSeaImpDirectMAWBDetail,
    b64id,
    accessedPermission
}) => {
    const [disableSubmit, setDisableSubmit] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFSICountry(token, user_id));
            dispatch(getFFSISeaport(token, user_id));
        }
    }, []);

    let [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    let [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);

    let [shipperBranchOptions, setShipperBranchOptions] = useState([]);
    let [consigneeBranchOptions, setConsigneeBranchOptions] = useState([]);

    let [shipperBankOptions, setShipperBankOptions] = useState([]);
    let [consigneeBankOptions, setConsigneeBankOptions] = useState([]);

    let [countryOptions, setCountryOptions] = useState([]);
    let [stateOptions, setStateOptions] = useState([]);
    let [cityOptions, setCityOptions] = useState([]);
    let [seaportOptions, setSeaportOptions] = useState([]);

    useEffect(() => {
        if (organisationOptions) {
            let shipperArr = [];
            let consigneeArr = [];

            organisationOptions.map(object => {
                if (object.entity && object.entity.includes("shipper")) {
                    shipperArr.push(object);
                }
                if (object.entity && object.entity.includes("consignee")) {
                    consigneeArr.push(object);
                }
            });
            setShipperOrganisationOptions(shipperArr);
            setConsigneeOrganisationOptions(consigneeArr);
        }
    }, [organisationOptions]);


    const handleShipperBranch = (shipper_id) => {
        if (shipper_id && token && user_id) {
            dispatch(getFFSeaImpShipperBranch(token, user_id, shipper_id));
        }
    };
    const handleShipperBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFSeaImpShipperBranchBank(token, user_id, branch_id));
        }
    };

    const handleConsigneeBranch = (consignee_id) => {
        if (consignee_id && token && user_id) {
            dispatch(getFFSeaImpConsigneeBranch(token, user_id, consignee_id));
        }
    };
    const handleConsigneeBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFSeaImpConsigneeBranchBank(token, user_id, branch_id));
        }
    };


    const {
        //organisation shipper branch list
        loadingFFSeaImpShipperBranchList,
        FFSeaImpShipperBranchList,
        FFSeaImpShipperBranchListError,

        //organisation consignee branch list
        loadingFFSeaImpConsigneeBranchList,
        FFSeaImpConsigneeBranchList,
        FFSeaImpConsigneeBranchListError,

        //organisatoin shipper branch bank list
        loadingFFSeaImpShipperBranchBankList,
        FFSeaImpShipperBranchBankList,
        FFSeaImpShipperBranchBankListError,

        //organisatoin consignee branch bank list
        loadingFFSeaImpConsigneeBranchBankList,
        FFSeaImpConsigneeBranchBankList,
        FFSeaImpConsigneeBranchBankListError,


        //country city state seaport
        loadingFFSICountry,
        FFSICountry,
        FFSICountryError,
        loadingFFSIState,
        FFSIState,
        FFSIStateError,
        loadingFFSICity,
        FFSICity,
        FFSICityError,
        loadingFFSISeaport,
        FFSISeaport,
        FFSISeaportError,
    } = useSelector(state => state.FFSeaImpReducer);


    useEffect(() => {
        if (FFSICountry) {
            let arr = [];
            FFSICountry.map(val => arr.push({ value: val.id, label: val.name }));
            setCountryOptions(arr);
        }
    }, [loadingFFSICountry, FFSICountry])

    useEffect(() => {
        if (FFSIState) {
            let arr = [];
            FFSIState.map(val => arr.push({ value: val.id, label: val.name }));
            setStateOptions(arr);
        }
    }, [loadingFFSIState, FFSIState]);

    useEffect(() => {
        if (FFSICity) {
            let arr = [];
            FFSICity.map(val => arr.push({ value: val.id, label: val.name }));
            setCityOptions(arr);
        }
    }, [loadingFFSICity, FFSICity])
    useEffect(() => {
        if (FFSISeaport) {
            let arr = [];
            FFSISeaport.map(val => arr.push({ value: val.id, label: val.name }));
            setSeaportOptions(arr);
        }
    }, [loadingFFSISeaport, FFSISeaport])


    useEffect(() => {
        // console.log(FFSeaImpShipperBranchList);
        if (FFSeaImpShipperBranchList) {
            let arr = [];
            FFSeaImpShipperBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setShipperBranchOptions(arr);
        }
    }, [FFSeaImpShipperBranchList]);

    useEffect(() => {
        if (FFSeaImpShipperBranchBankList) {
            let arr = [];
            FFSeaImpShipperBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setShipperBankOptions(arr);
        }
    }, [FFSeaImpShipperBranchBankList]);

    useEffect(() => {
        if (FFSeaImpConsigneeBranchList) {
            let arr = [];
            FFSeaImpConsigneeBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setConsigneeBranchOptions(arr);
        }
    }, [FFSeaImpConsigneeBranchList]);

    useEffect(() => {
        if (FFSeaImpConsigneeBranchBankList) {
            let arr = [];
            FFSeaImpConsigneeBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setConsigneeBankOptions(arr);
        }
    }, [FFSeaImpConsigneeBranchBankList]);


    const initialValues = {
        job_order_id: 0,
        quotation_id: 0,
        shipper_id: 0,
        shipper_branch_id: 0,
        shipper_branch_address_id: 0,
        consignee_id: 0,
        consignee_branch_id: 0,
        consignee_branch_address_id: 0,
        notify_address: "",
        notify_email_address: "",
        place_of_acceptance: "",
        port_of_loading: "",
        port_of_discharge: "",
        place_of_delivery: "",
        vessel_and_voyage_no: "",
        product_description_json: "",
        freight_term: "",
        freight_payable_at: "",
        number_of_original_mdt: "",
        place_of_issue: "",
        place_of_date: "",
        other_particular_address: "",
        other_particular_country: "",
        other_particular_city: "",
        other_particular_state: "",
        other_particular_zipcode: "",
        shipped_on_board_date: "",
        delivery_of_goods_apply_to_address: "",
        delivery_of_goods_apply_to_email: "",
        delivery_of_goods_apply_to_tax_id: "",
        delivery_of_goods_apply_to_zc: "",
        is_sli_recived: "",
        rows: [
            {
                no_of_package: "0",
                goods_description: "",
                gross_weight: "",
                gross_weight_unit: "",
                measurement: "",
                invoice_no: "",
                sb_no: "",
                sb_date: "",
                net_weight: "",
                net_weight_unit: "",
                container_number: ""
            }
        ]
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            // console.log(values);
            values.job_order_id = job_order_id;
            values.quotation_id = quotation_id;

            values.product_description_json = values.rows
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                let id = atob(b64id);
                if (!id) {
                    toast.error("HBL id not found. Please assign HBL id to update.");
                    return;
                }
                values.id = id;
                axios.post(`${adminMainUrl}/api/freight/forwarding/sea/import/direct-shipment/mbl/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            // resetForm();
                            //reset all the dropdowns
                            setShipperOrganisationOptions([]);
                            setConsigneeOrganisationOptions([]);
                            setShipperBranchOptions([]);
                            setConsigneeBranchOptions([]);
                            resetForm();
                            navigate(`/flexichain/job-order/freight-forwarding/shipment/sea/import/direct/mbl`)

                            // navigate(`/flexichain/job-order/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (formik.values.other_particular_country) {
            dispatch(getFFSIState(token, user_id, formik.values.other_particular_country));
        }
    }, [formik.values.other_particular_country])
    useEffect(() => {
        if (formik.values.other_particular_state) {
            dispatch(getFFSICity(token, user_id, formik.values.other_particular_state));
        }
    }, [formik.values.other_particular_state])

    useEffect(() => {
        if (FFSeaImpDirectMAWBDetail) {
            // console.log("FFSeaImpDirectMAWBDetail", FFSeaImpDirectMAWBDetail);
            formik.setFieldValue("job_order_id", FFSeaImpDirectMAWBDetail.job_order_id);
            formik.setFieldValue("quotation_id", FFSeaImpDirectMAWBDetail.quotation_id);
            formik.setFieldValue("shipper_id", FFSeaImpDirectMAWBDetail.shipper_id);
            if (FFSeaImpDirectMAWBDetail.shipper_id) {
                handleShipperBranch(FFSeaImpDirectMAWBDetail.shipper_id);
            }
            formik.setFieldValue("shipper_branch_id", FFSeaImpDirectMAWBDetail.shipper_branch_id);

            // formik.setFieldValue("shipper_branch_address_id", FFSeaImpDirectMAWBDetail.shipper_branch_address_id);
            formik.setFieldValue("consignee_id", FFSeaImpDirectMAWBDetail.consignee_id);
            if (FFSeaImpDirectMAWBDetail.consignee_id) {
                handleConsigneeBranch(FFSeaImpDirectMAWBDetail.consignee_id);
            }
            formik.setFieldValue("consignee_branch_id", FFSeaImpDirectMAWBDetail.consignee_branch_id);

            // formik.setFieldValue("consignee_branch_address_id", FFSeaImpDirectMAWBDetail.consignee_branch_address_id);
            formik.setFieldValue("notify_address", FFSeaImpDirectMAWBDetail.notify_address);
            formik.setFieldValue("notify_email_address", FFSeaImpDirectMAWBDetail.notify_email_address);
            formik.setFieldValue("place_of_acceptance", FFSeaImpDirectMAWBDetail.place_of_acceptance);
            formik.setFieldValue("port_of_loading", FFSeaImpDirectMAWBDetail.port_of_loading);
            formik.setFieldValue("port_of_discharge", FFSeaImpDirectMAWBDetail.port_of_discharge);
            formik.setFieldValue("place_of_delivery", FFSeaImpDirectMAWBDetail.place_of_delivery);
            formik.setFieldValue("vessel_and_voyage_no", FFSeaImpDirectMAWBDetail.vessel_and_voyage_no);
            formik.setFieldValue("product_description_json", FFSeaImpDirectMAWBDetail.product_description_json);
            formik.setFieldValue("freight_term", FFSeaImpDirectMAWBDetail.freight_term);
            formik.setFieldValue("freight_payable_at", FFSeaImpDirectMAWBDetail.freight_payable_at);
            formik.setFieldValue("number_of_original_mdt", FFSeaImpDirectMAWBDetail.number_of_original_mdt);
            formik.setFieldValue("place_of_issue", FFSeaImpDirectMAWBDetail.place_of_issue);
            formik.setFieldValue("place_of_date", FFSeaImpDirectMAWBDetail.place_of_date);
            formik.setFieldValue("other_particular_address", FFSeaImpDirectMAWBDetail.other_particular_address);
            formik.setFieldValue("other_particular_country", FFSeaImpDirectMAWBDetail.other_particular_country);
            formik.setFieldValue("other_particular_city", FFSeaImpDirectMAWBDetail.other_particular_city);
            formik.setFieldValue("other_particular_state", FFSeaImpDirectMAWBDetail.other_particular_state);
            formik.setFieldValue("other_particular_zipcode", FFSeaImpDirectMAWBDetail.other_particular_zipcode);
            formik.setFieldValue("shipped_on_board_date", FFSeaImpDirectMAWBDetail.shipped_on_board_date);
            formik.setFieldValue("delivery_of_goods_apply_to_address", FFSeaImpDirectMAWBDetail.delivery_of_goods_apply_to_address);
            formik.setFieldValue("delivery_of_goods_apply_to_email", FFSeaImpDirectMAWBDetail.delivery_of_goods_apply_to_email);
            formik.setFieldValue("delivery_of_goods_apply_to_tax_id", FFSeaImpDirectMAWBDetail.delivery_of_goods_apply_to_tax_id);
            formik.setFieldValue("delivery_of_goods_apply_to_zc", FFSeaImpDirectMAWBDetail.delivery_of_goods_apply_to_zc);
            formik.setFieldValue("is_sli_recived", FFSeaImpDirectMAWBDetail.is_sli_recived);
            // formik.setFieldValue("rows", FFSeaImpDirectMAWBDetail.hbl_product_list);

            if (FFSeaImpDirectMAWBDetail?.mbl_product_list && Array.isArray(FFSeaImpDirectMAWBDetail?.mbl_product_list)) {
                // let arr = FFSeaImpDirectMAWBDetail.mbl_product_list;
                // formik.setFieldValue("rows", arr);
                const arr = FFSeaImpDirectMAWBDetail.mbl_product_list.map((item) => ({
                    no_of_package: item.no_of_package || "",
                    goods_description: item.goods_description || "",
                    gross_weight: item.gross_weight || "",
                    gross_weight_unit: item.gross_weight_unit || "",
                    measurement: item.measurement || "",
                    invoice_no: item.invoice_no || "",
                    sb_no: item.sb_no || "",
                    sb_date: item.sb_date || "",
                    net_weight: item.net_weight || "",
                    net_weight_unit: item.net_weight_unit || "",
                    container_number: item.container_number || "",
                }));

                // console.log("Mapped Rows:", arr); // Check the mapped rows
                formik.setFieldValue("rows", arr);
            }
        }
    }, [FFSeaImpDirectMAWBDetail])


    // useEffect(() => {
    //     // Perform calculations and update the rows without causing an infinite loop
    //     const calculateFreight = () => {
    //         const updatedRows = formik.values.rows.map((row) => {
    //             const num1 = Number(row.chargeable_wt);
    //             const num2 = Number(row.rate_charge);

    //             return {
    //                 ...row,
    //                 total_freight: !isNaN(num1) && !isNaN(num2) ? num1 * num2 : "",
    //             };
    //         });

    //         // Only update the rows if something changed to prevent unnecessary updates
    //         if (JSON.stringify(formik.values.rows) !== JSON.stringify(updatedRows)) {
    //             formik.setFieldValue("rows", updatedRows, false); // Set `shouldValidate` to `false` to avoid validation triggering on each update
    //         }
    //     };

    //     calculateFreight();
    // }, [formik.values.rows.map(row => row.chargeable_wt), formik.values.rows.map(row => row.rate_charge)]);


    // useEffect(() => {
    //     if (formik.values.chargeable_wt1 && formik.values.rate_charge1) {
    //         let num1 = Number(formik.values.chargeable_wt1);
    //         let num2 = Number(formik.values.rate_charge1);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight1", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight1", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight1", "");
    //     }
    // }, [formik.values.chargeable_wt1, formik.values.rate_charge1]);

    // useEffect(() => {
    //     if (formik.values.chargeable_wt2 && formik.values.rate_charge2) {
    //         let num1 = Number(formik.values.chargeable_wt2);
    //         let num2 = Number(formik.values.rate_charge2);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight2", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight2", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight2", "");
    //     }
    // }, [formik.values.chargeable_wt2, formik.values.rate_charge2]);

    // useEffect(() => {
    //     if (formik.values.chargeable_wt3 && formik.values.rate_charge3) {
    //         let num1 = Number(formik.values.chargeable_wt3);
    //         let num2 = Number(formik.values.rate_charge3);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight3", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight3", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight3", "");
    //     }
    // }, [formik.values.chargeable_wt3, formik.values.rate_charge3])

    // useEffect(() => {
    //     if (formik.values.chargeable_wt4 && formik.values.rate_charge4) {
    //         let num1 = Number(formik.values.chargeable_wt4);
    //         let num2 = Number(formik.values.rate_charge4);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight4", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight4", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight4", "");
    //     }
    // }, [formik.values.chargeable_wt4, formik.values.rate_charge4])

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_prepaid)) ? Number(formik.values.weight_charge_prepaid) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_prepaid)) ? Number(formik.values.valuation_charge_prepaid) : 0;
        let num3 = !isNaN(Number(formik.values.tax_prepaid)) ? Number(formik.values.tax_prepaid) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_prepaid)) ? Number(formik.values.total_due_agent_prepaid) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_prepaid)) ? Number(formik.values.total_due_carrier_prepaid) : 0;
        formik.setFieldValue("total_prepaid", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_prepaid,
        formik.values.valuation_charge_prepaid,
        formik.values.tax_prepaid,
        formik.values.total_due_agent_prepaid,
        formik.values.total_due_carrier_prepaid,
    ]);

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_collect)) ? Number(formik.values.weight_charge_collect) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_collect)) ? Number(formik.values.valuation_charge_collect) : 0;
        let num3 = !isNaN(Number(formik.values.tax_collect)) ? Number(formik.values.tax_collect) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_collect)) ? Number(formik.values.total_due_agent_collect) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_collect)) ? Number(formik.values.total_due_carrier_collect) : 0;
        formik.setFieldValue("total_collect", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_collect,
        formik.values.valuation_charge_collect,
        formik.values.tax_collect,
        formik.values.total_due_agent_collect,
        formik.values.total_due_carrier_collect,
    ]);


    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);
    const [disableDownloadDOC, setDisableDownloadDOC] = useState(false);


    const downloadSLIPDF = () => {
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/sea/export/hbl/sli-pdf-download`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.pdf');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }

    const downloadSLIDOC = () => {
        setDisableDownloadDOC(true);
        let config = {
            headers: { 'auth-token': token, user_id: user_id },
            responseType: 'blob' // Ensure the response is treated as a binary blob
        };

        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/export/hawb/sli-doc-download`, config)
                .then(response => {
                    if (response.status === 200) {
                        // Create a Blob object from the response data
                        const blob = new Blob([response.data], { type: 'application/msword' });
                        const url = window.URL.createObjectURL(blob);

                        // Create an anchor element and trigger the download
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.doc'); // Set the filename
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link); // Clean up the DOM
                        setDisableDownloadDOC(false);
                    } else {
                        toast.error(response.error.message || "Error downloading the document");
                        setDisableDownloadDOC(false);
                    }
                })
                .catch(error => {
                    console.error(error);
                    toast.error(error.message || "Error during download");
                    setDisableDownloadDOC(false);
                });
        } catch (error) {
            console.error(error);
            toast.error(error.message || "Unexpected error occurred");
            setDisableDownloadDOC(false);
        }
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <h3 className='mt-2'>Direct Shipment MBL</h3>
                    <h4 className='mt-2'>Party Details</h4>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                SLI received
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className='form-control form-control-sm'
                                    name="is_sli_recived"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.is_sli_recived}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2 d-flex align-items-center justify-content-end">
                        <div className="row d-flex justify-content-end">
                            {accessedPermission.includes("ff_se_console_shipment_hbl_sli_download") && <div className="col-md-6"><button className="btn btn-sm btn-primary" type="button" onClick={downloadSLIPDF} disabled={disableDownloadPDF}>{disableDownloadPDF ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (PDF)</>}</button></div>}
                            {/* {accessedPermission.includes("ff_se_console_shipment_hbl_sli_download") && <div className="col-md-6"><button className="btn btn-sm btn-primary" type="button" onClick={downloadSLIDOC} disabled={disableDownloadDOC} style={{ whiteSpace: "nowrap" }}>{disableDownloadDOC ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (DOC)</>}</button></div>} */}
                            {accessedPermission.includes("ff_se_console_shipment_hbl_sli_download") && <div className="col-md-6"><Link className="btn btn-sm btn-primary" type="button" style={{ whiteSpace: "nowrap" }} to={`${adminMainUrl}/FreightForwardingSLI/FF_AI_SLI.docx`}>{disableDownloadDOC ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (DOC)</>}</Link></div>}

                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperOrganisationOptions}
                                    styles={customStyles}
                                    name="shipper_id"
                                    onChange={option => {
                                        formik.setFieldValue("shipper_branch_id", "");
                                        setShipperBranchOptions([]);
                                        formik.setFieldValue('shipper_id', option.value);
                                        handleShipperBranch(option.value);
                                    }}
                                    value={shipperOrganisationOptions.find(option => option.value === formik.values.shipper_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperBranchOptions}
                                    styles={customStyles}
                                    name="shipper_branch_id"
                                    onChange={option => {
                                        formik.setFieldValue('shipper_branch_id', option.value);
                                        handleShipperBanks(option.value);
                                    }}
                                    value={shipperBranchOptions.find(option => option.value === formik.values.shipper_branch_id || null)}
                                    isLoading={loadingFFSeaImpShipperBranchList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeOrganisationOptions}
                                    styles={customStyles}
                                    name="quotation_id"
                                    onChange={option => {
                                        setConsigneeBranchOptions([]);
                                        formik.setFieldValue("consignee_branch_id", "");
                                        formik.setFieldValue('consignee_id', option.value);
                                        handleConsigneeBranch(option.value);
                                    }}
                                    value={consigneeOrganisationOptions.find(option => option.value === formik.values.consignee_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeBranchOptions}
                                    styles={customStyles}
                                    name="consignee_branch_id"
                                    onChange={option => {
                                        formik.setFieldValue('consignee_branch_id', option.value);
                                        handleConsigneeBanks(option.value);
                                    }}
                                    value={consigneeBranchOptions.find(option => option.value === formik.values.consignee_branch_id || null)}
                                    isLoading={loadingFFSeaImpShipperBranchList}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>


                    {/* Notify  */}
                    <div className="col-md-12 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Notify Address
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <textarea
                                    className='form-control'
                                    id="notify_address"
                                    name="notify_address"
                                    value={formik.values.notify_address}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <InputTextJSX labelText={"Notify Email"} nameValue={"notify_email_address"} value={formik.values.notify_email_address} onChange={formik.handleChange} maxLength={100} />
                    <InputTextJSX labelText={"Place of acceptance"} nameValue={"place_of_acceptance"} value={formik.values.place_of_acceptance} onChange={formik.handleChange} maxLength={250} />

                    {/* Ports of loading and discharge */}
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Port of Loading
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={seaportOptions}
                                    styles={customStyles}
                                    name="port_of_loading"
                                    onChange={option => {
                                        formik.setFieldValue('port_of_loading', option.value);
                                    }}
                                    value={seaportOptions.find(option => option.value == formik.values.port_of_loading || null)}
                                    isLoading={loadingFFSeaImpConsigneeBranchBankList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Port of Discharge
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={seaportOptions}
                                    styles={customStyles}
                                    name="port_of_discharge"
                                    onChange={option => {
                                        formik.setFieldValue('port_of_discharge', option.value);
                                    }}
                                    value={seaportOptions.find(option => option.value == formik.values.port_of_discharge || null)}
                                    isLoading={loadingFFSeaImpConsigneeBranchBankList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <InputTextJSX labelText={"Place of delivery"} nameValue={"place_of_delivery"} value={formik.values.place_of_delivery} onChange={formik.handleChange} maxLength={250} />
                    <InputTextJSX labelText={"Vessel & Voyage No."} nameValue={"vessel_and_voyage_no"} value={formik.values.vessel_and_voyage_no} onChange={formik.handleChange} maxLength={250} />
                    <InputTextJSX labelText={"Freight Term"} nameValue={"freight_term"} value={formik.values.freight_term} onChange={formik.handleChange} maxLength={250} />
                    <InputTextJSX labelText={"Freight Payable At"} nameValue={"freight_payable_at"} value={formik.values.freight_payable_at} onChange={formik.handleChange} maxLength={250} />

                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                No. of Original MTDs
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="text"
                                    maxlength={10}
                                    className="form-control form-control-sm"
                                    id="number_of_original_mdt"
                                    name="number_of_original_mdt"
                                    value={formik.values.number_of_original_mdt}
                                    onChange={formik.handleChange}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <InputTextJSX labelText={"Place of issue"} nameValue={"place_of_issue"} value={formik.values.place_of_issue} onChange={formik.handleChange} />
                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Date of Issue
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id="place_of_date"
                                    name="place_of_date"
                                    value={formik.values.place_of_date}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>
                    </div>


                    <h4 className='mt-2'>For delivery of goods please apply to:</h4>
                    <InputTextJSX labelText={"Address"} nameValue={"delivery_of_goods_apply_to_address"} value={formik.values.delivery_of_goods_apply_to_address} onChange={formik.handleChange} maxLength={250} />
                    <InputTextJSX labelText={"Email"} nameValue={"delivery_of_goods_apply_to_email"} value={formik.values.delivery_of_goods_apply_to_email} onChange={formik.handleChange} maxlength={60} />
                    <InputTextJSX labelText={"Tax ID"} nameValue={"delivery_of_goods_apply_to_tax_id"} value={formik.values.delivery_of_goods_apply_to_tax_id} onChange={formik.handleChange} maxlength={20} />
                    <InputTextJSX labelText={"ZC"} nameValue={"delivery_of_goods_apply_to_zc"} value={formik.values.delivery_of_goods_apply_to_zc} onChange={formik.handleChange} maxlength={10} />

                    <h4 className='mt-2'>Rate Description</h4>
                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Container No.(s)*</th>
                                    <th scope="col">Marks & Number*</th>
                                    <th scope="col">Invoice Number</th>
                                    <th scope="col">SB Number.*</th>
                                    <th scope="col">SB Date*</th>
                                    <th scope="col">Total Gross Weight*</th>
                                    <th scope="col">Gross Weight Unit*</th>
                                    <th scope="col">Total Net Weight*</th>
                                    <th scope="col">Net Weight Unit*</th>
                                    <th scope="col">Measurement of Goods</th>
                                    <th scope="col">Goods Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formik.values.rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].container_number`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                maxlength={100}
                                                value={row.container_number}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                maxlength={50}
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].no_of_package`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.no_of_package}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                maxlength={50}
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].invoice_no`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.invoice_no}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                maxlength={50}
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].sb_no`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.sb_no}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].sb_date`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.sb_date}
                                                min="1900-01-01"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].gross_weight`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.gross_weight}
                                                maxLength={10}
                                                onInput={(event) => {
                                                    let value = event.target.value;

                                                    value = value.replace(/[^0-9.]/g, '');

                                                    const parts = value.split('.');

                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }

                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }

                                                    event.target.value = value;
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].gross_weight_unit`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.gross_weight_unit}
                                            >
                                                <option value="" disabled>-</option>
                                                <option value="Kgs">Kgs</option>
                                                <option value="Lbs">Lbs</option>
                                                <option value="Ton">Ton</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].net_weight`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.net_weight}
                                                maxLength={10}
                                                onInput={(event) => {
                                                    let value = event.target.value;

                                                    value = value.replace(/[^0-9.]/g, '');

                                                    const parts = value.split('.');

                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }

                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }

                                                    event.target.value = value;
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].net_weight_unit`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.net_weight_unit}
                                            >
                                                <option value="" disabled>-</option>
                                                <option value="Kgs">Kgs</option>
                                                <option value="Lbs">Lbs</option>
                                                <option value="Ton">Ton</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].measurement`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.measurement}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                className='form-control'
                                                rows={2}
                                                name={`rows[${index}].goods_description`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.goods_description}
                                            ></textarea>
                                        </td>
                                        <td>
                                            {formik.values.rows.length > 1 && (
                                                <button
                                                    type="button"
                                                    title='Remove rates'
                                                    className="btn btn-sm btn-danger me-1"
                                                    onClick={() => {
                                                        const newRows = formik.values.rows.filter(
                                                            (_, i) => i !== index
                                                        );
                                                        formik.setFieldValue("rows", newRows);
                                                    }}
                                                >
                                                    -
                                                </button>
                                            )}
                                            {index === formik.values.rows.length - 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary ms-1"
                                                    onClick={() => {
                                                        const newRows = [...formik.values.rows];
                                                        newRows.push({
                                                            no_of_pkg: "",
                                                            gross_wt: "",
                                                            kg_lb: "",
                                                            rate_class: "",
                                                            comm_item_No: "",
                                                            chargeable_wt: "",
                                                            rate_charge: "",
                                                            total_freight: "",
                                                        });
                                                        formik.setFieldValue("rows", newRows);
                                                    }}
                                                >
                                                    +
                                                </button>
                                            )}

                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>


                    <h4 className='mt-2'>Other Particulars</h4>
                    <InputTextJSX labelText={"Address"} nameValue={"other_particular_address"} value={formik.values.other_particular_address} onChange={formik.handleChange} maxLength={250} />
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Country
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={countryOptions}
                                    styles={customStyles}
                                    name="other_particular_country"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_country', option.value);
                                    }}
                                    value={countryOptions.find(option => option.value == formik.values.other_particular_country || null)}
                                    isLoading={loadingFFSICountry}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                State
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={stateOptions}
                                    styles={customStyles}
                                    name="other_particular_state"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_state', option.value);
                                    }}
                                    value={stateOptions.find(option => option.value == formik.values.other_particular_state || null)}
                                    isLoading={loadingFFSIState}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                City
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={cityOptions}
                                    styles={customStyles}
                                    name="other_particular_city"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_city', option.value);
                                    }}
                                    value={cityOptions.find(option => option.value == formik.values.other_particular_city || null)}
                                    isLoading={loadingFFSICity}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <InputTextJSX labelText={"Zip Code"} nameValue={"other_particular_zipcode"} value={formik.values.other_particular_zipcode} onChange={formik.handleChange} maxlength={6} /> */}
                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Zip Code
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="text"
                                    maxLength={6}
                                    className="form-control form-control-sm"
                                    id={"other_particular_zipcode"}
                                    name={"other_particular_zipcode"}
                                    value={formik.values.other_particular_zipcode}
                                    onChange={formik.handleChange}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row d-flex justify-content-end mt-2">
                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                        </button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default DirectShipmentSIMBLEdit